import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import NavBg from '../../images/ui/nav-bar-bg.png';
import Arrow from '../../images/ui/global-nav-arrow.svg';

export default function MainNav() {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <nav id="main-nav-wrapper" className={`${isOpen ? 'active' : ''}`}>
      <img src={NavBg} className="bg" />
      <div
        id="nav-toggle"
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        <img src={Arrow} className="arrow" />
      </div>
      <ul id="main-nav">
        <li>
          <Link
            to="/oticon-more-overview"
            onClick={() => {
              setIsOpen(false);
            }}
          >
            Oticon More™
            <br />
            Overview
          </Link>
        </li>
        <li className="divider" />
        <li>
          <Link
            to="/brainhearing-technology"
            onClick={() => {
              setIsOpen(false);
            }}
          >
            Technology
          </Link>
        </li>
        <li className="divider" />
        <li>
          <Link
            to="/evidence"
            onClick={() => {
              setIsOpen(false);
            }}
          >
            Evidence
          </Link>
        </li>
        <li className="divider" />
        <li>
          <Link
            to="/connectivity"
            onClick={() => {
              setIsOpen(false);
            }}
          >
            Connectivity
          </Link>
        </li>
        <li className="divider" />
        <li>
          <Link
            to="/family-overview"
            onClick={() => {
              setIsOpen(false);
            }}
          >
            Family Overview
          </Link>
        </li>
      </ul>
    </nav>
  );
}
